import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TextField } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';

import validate from './validate';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';

import * as validator from 'helpers/Validator';

const CreateOwnerForm = (
  <div>
    <div className="row">
      <div className="col-sm-6">
        <Field
          name="first_name"
          type="text"
          component={TextField}
          floatingLabelText="First Name"
          style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
        />
      </div>
      <div className="col-sm-6">
        <Field
          name="last_name"
          type="text"
          component={TextField}
          floatingLabelText="Last Name"
          style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
        />
      </div>
    </div>

    <div className="row">
      <div className="col-sm-12">
        <Field
          name="email"
          type="email"
          component={TextField}
          floatingLabelText="Email"
          validate={[validator.validEmail]}
          style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
        />
      </div>
    </div>
  </div>
);

class OwnerDetails extends Component {
  render() {
    const { handleSubmit, owners } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>Owner Details</h3>
            <Field
              component={MultiSelectExtended}
              name="owners"
              hintText="Owners"
              createText="Add new owner"
              createComponent={CreateOwnerForm}
              data={owners}
              multiple
              style={{ margin: '30px auto 25px auto', width: '75%' }}
            />
          </div>
        </form>
      </div>
    );
  }
}

OwnerDetails = connect(store => {
  return {
    owners: store.landlordProperties.owners,
  };
})(OwnerDetails);

OwnerDetails = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  validate,
})(OwnerDetails);

export default OwnerDetails;
